import React from 'react';
import { Page } from '../Common/Components/Page';
import { PresetManagementContent } from './Components/PresetManagementContent';

export const PresetManagement = (): React.JSX.Element => (
  <Page title={'Presets'} accessKey={'presets'} isSearchable={true}>
    <PresetManagementContent />
  </Page>
);
